import Select, { StylesConfig } from 'react-select';
import style from './NotePreferences.module.scss';
import InfoModal from '@/components/InfoModal/index.tsx';
import { useState } from 'react';
import styles from '@/modules/NotePreferences/NotePreferences.module.scss';
import infoIcon from '@image/info-icon.svg';

const customStyles: StylesConfig = {
  control: (provided: Record<string, unknown>, state: any) => ({
    ...provided,
    border: state.isFocused ? '1px solid #344bc6' : '1px solid #e0e0e0',
    boxShadow: state.isFocused ? '0px 0px 2px #344bc6' : 'none',
    '&:hover': {
      border: '1px solid #344bc6',
      boxShadow: '0px 0px 2px #344bc6',
    },
  }),
  option: (styles, state) => ({
    ...styles,
    backgroundColor: state.isSelected ? '#344bc6' : 'none',
  }),
};

const NotePreferencesToggle = (props: {
  title: string;
  attributeName: string;
  options: any[];
  value: string;
  onValueChanged: (a: string, b: string) => void;
  disabled?: boolean;
  hint?: { title: string; content: { title: string; value: string }[] };
  analyticsProperties?: { preferenceType: string; noteSection: string };
}) => {
  const {
    title,
    attributeName,
    options,
    value,
    onValueChanged,
    disabled,
    hint,
    analyticsProperties,
  } = props;
  const [isPreferencesModalOpen, setIsPreferencesModalOpen] = useState(false);

  const selectedValue = {
    value: value,
    label: value,
  };

  return (
    <div className={style.select__container}>
      <InfoModal
        modalOpen={isPreferencesModalOpen}
        modalClose={() => setIsPreferencesModalOpen(false)}
        content={hint}
        analyticsProperties={analyticsProperties}
      />
      <div className={styles.select__label}>
        <label className={styles.toggle__label}>{title}</label>
        {hint && (
          <img
            className={styles.info__icon}
            onClick={() => setIsPreferencesModalOpen(true)}
            src={infoIcon}
            alt="info"
          />
        )}
      </div>
      <Select
        styles={customStyles}
        classNames={{
          dropdownIndicator: () => {
            return style.custom_dropdown_indicator;
          },
        }}
        classNamePrefix="select"
        defaultValue={selectedValue}
        isDisabled={disabled}
        name={attributeName}
        options={options}
        onChange={(selectedOption: any) => {
          onValueChanged(attributeName, selectedOption?.value);
        }}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary: '#3173b1',
            neutral20: '#e0e0e0',
            neutral30: '#e0e0e0',
          },
        })}
      />
    </div>
  );
};

export default NotePreferencesToggle;
